module.exports = global["$"] = require("-!/Users/shiba/Sites/suita-hosp/node_modules/expose-loader/index.js?jQuery!./jquery.js");